import { useParams } from 'react-router-dom'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Link } from 'react-router-dom'
import { UserCircle } from 'lucide-react'

export default function TeamMemberProfilePlaceholder() {
  const { id } = useParams<{ id: string }>()

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-3xl mx-auto space-y-6">
        <header className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <UserCircle className="w-6 h-6 text-primary" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-foreground">Team member profile</h1>
            <p className="text-muted-foreground">Member ID: <span className="font-mono">{id}</span></p>
          </div>
        </header>

        <Card className="border-dashed">
          <CardHeader>
            <CardTitle>Profile details coming soon</CardTitle>
            <CardDescription>
              Port the profile summary, feedback history, and role management widgets to this page to complete the migration.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <Button asChild>
              <Link to="/dashboard/team">Back to team dashboard</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
